import type { AdminRouterItem } from '../router';
import {
  AppsListRegular,
  PeopleLockRegular,
  TimerRegular,
} from '@fluentui/react-icons';
import Dashboard from '.';
import RolePage from './components/role.tsx';
import DetailView from './components/detailView.tsx';
import Timetracking from './components/timetracking.tsx';
import AllTimetracking from './components/alltimetracking.tsx';

const dashboardRoutes: AdminRouterItem[] = [
  {
    path: '',
    element: <Dashboard />,
    meta: {
      label: 'Dashboard',
      title: 'Dashboard',
      key: '/',
      icon: <AppsListRegular />,
      allowedRoles: ['Admin', 'Personal', 'GF', 'Lehrling'],
    },
  },
  {
    path: 'detail',
    element: <DetailView />,
    meta: {
      label: 'Detail',
      title: 'Detail',
      key: '/detail',
      hideInMenu: true,
      allowedRoles: ['Admin', 'Personal', 'GF', 'Lehrling'],
    },
  },
  {
    path: 'role',
    element: <RolePage />,
    meta: {
      label: 'Rollenverwaltung',
      title: 'Rollenverwaltung',
      key: '/role',
      icon: <PeopleLockRegular />,
      allowedRoles: ['Admin'],
    },
  },
  {
    path: 'timetracking',
    element: <Timetracking />,
    meta: {
      label: 'Timetracking',
      title: 'Timetracking',
      key: '/timetracking',
      hideInMenu: true,
      allowedRoles: ['Admin', 'Personal', 'GF', 'Lehrling'],
    },
  },
  {
    path: 'alltimetracking',
    element: <AllTimetracking />,
    meta: {
      label: 'Timetracking',
      title: 'Timetracking',
      key: '/alltimetracking',
      icon: <TimerRegular />,
      allowedRoles: ['Admin', 'Personal', 'GF', 'Lehrling'],
    },
  },
];

export default dashboardRoutes;
